import { SFC } from 'react'
import OriginalCol from 'reactstrap/lib/Col'

export type ColumnProps =
  | ColumType
  | {
      size?: ColumType
      offset?: string | number
    }

type ColumType = ColSizeString | ColSize | boolean
type ColSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
type ColSizeString = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | 'auto'

export interface ColProps extends React.HTMLProps<HTMLDivElement> {
  tag?: React.ReactType
  xs?: ColumnProps
  sm?: ColumnProps
  md?: ColumnProps
  lg?: ColumnProps
  xl?: ColumnProps

  // custom widths
  widths?: string[]
}

export const Col = OriginalCol as SFC<ColProps>



// WEBPACK FOOTER //
// ./src/modules/flex-layout/col.tsx